import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Listbox } from '@headlessui/react';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { fetchJson } from '../../../api';
import { useCategoryStore } from '../../../store/category';
import { useGlobalStore } from '../../../store/global';
import { ProductCard } from '../../product/product-card';
import CategoryPagination from './category-pagination';
function Sort({ count, isFetching }) {
    const sort = useCategoryStore((state) => state.category.sort);
    const filter = useCategoryStore((state) => state.filter);
    const setFilter = useCategoryStore((state) => state.setFilter);
    const texts = useGlobalStore((state) => state.config.texts);
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: 'col-12 col-sm-7 col-md-8', children: isFetching ? _jsx("i", { className: "fa fa-spinner fa-spin ml-2" }) : _jsx("span", { children: `${count} ${texts['text173']}` }) }), _jsx("div", { className: 'col-12 col-sm-5 col-md-4', children: _jsx(Listbox, { name: "sort", value: filter.sort, onChange: (value) => setFilter({ sort: value }), children: ({ open }) => (_jsxs("div", { className: "react-custom-select attribute-select", children: [_jsxs(Listbox.Button, { children: [texts[sort.find((sortItem) => sortItem.value === filter.sort)?.name ?? '243'], _jsx("span", { className: open ? 'opened' : 'closed' })] }), _jsx(Listbox.Options, { children: sort.map((item, i) => (_jsx(Listbox.Option, { value: item.value, children: ({ active, selected }) => _jsx("div", { className: `item ${selected ? 'selected' : ''}`, children: texts[item.name] }) }, `select-${i}`))) })] })) }) })] }));
}
export default function CategoryProducts() {
    const pagination = useGlobalStore((state) => state.config.productPagination);
    const api = useGlobalStore((state) => state.config.api);
    const categoryId = useCategoryStore((state) => state.category.id);
    const filter = useCategoryStore((state) => state.filter);
    const [page, setPage] = React.useState(1);
    const productsRef = React.useRef(null);
    const products = useQuery(['products', categoryId, page, { ...filter }], async () => fetchJson(`${api.category.search}/${categoryId}?page=${page}&results=${pagination}`, {
        method: 'POST',
        body: JSON.stringify(filter),
    }), {
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
        refetchInterval: false,
        refetchIntervalInBackground: false,
        keepPreviousData: true,
    });
    const handlePaginationCLick = (page) => {
        setPage(page);
        if (productsRef.current)
            productsRef.current.scrollIntoView();
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { ref: productsRef, className: "row py-3 align-items-center", children: _jsx(Sort, { count: products.data?.meta.total ?? 0, isFetching: products.isFetching || products.isLoading }) }), _jsx("div", { className: `products mb-4 ${products.isFetching ? 'loading' : ''}`, children: products.data?.data && products.data?.data.map((product) => _jsx(ProductCard, { product: product }, `product-${product.id}`)) }), _jsx(CategoryPagination, { meta: products.data?.meta, pageSpread: 2, callback: (page) => handlePaginationCLick(page) })] }));
}
